import { useEffect, useState } from "react";
import { Box, Typography, Button, Stack, CircularProgress, Paper, Divider, Container, Grid, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getShippingCategories } from "../../../../../services/Admin/ShippingCategoriesApi";
import AddShippingCategoriesDialog from "./AddShippingCategoriesDialog";
import EditShippingCategoryDialog from "./EditShippingCategoryDialog";
import DeleteShippingCategoryDialog from "./DeleteShippingCategoryDialog";
import ShippingGovernotates from "../ShippingGovernorates/ShippingGovernotates";

const ShippingCategoriesTap = () => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [error, setError] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [openGovernoratesDialog, setOpenGovernoratesDialog] = useState(false);
  const [selectedCountryForView, setSelectedCountryForView] = useState(null);
  const [selectedCategoryForView, setSelectedCategoryForView] = useState(null);

  const fetch = async () => {
    setError("");
    setLoading(true);
    try {
      const res = await getShippingCategories();
      const data = res && res.success ? res.data : res;
      setGroups(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err?.message || "فشل تحميل شرائح الشحن");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const formatMoney = (v) => {
    if (v == null || v === "") return "-";
    const n = Number(v);
    return Number.isNaN(n) ? v : n.toFixed(2);
  };

  const handleEditClick = (category, countryId) => {
    setSelectedCategory(category);
    setSelectedCountryId(countryId);
    setOpenEditDialog(true);
  };

  const handleDeleteClick = (category) => {
    setCategoryToDelete(category);
    setOpenDeleteDialog(true);
  };

  const handleViewGovernoratesClick = (country, category) => {
    setSelectedCountryForView(country);
    setSelectedCategoryForView(category);
    setOpenGovernoratesDialog(true);
  };

  return (
    <Container maxWidth={false} sx={{ py: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Box>
            <Typography variant="h6">شرائح الشحن</Typography>
            <Typography variant="body2" color="text.secondary">عرض الشرائح مجمعة حسب الدول</Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Button startIcon={<AddIcon />} onClick={() => setOpenDialog(true)} size="small" variant="contained">
              إضافة شرائح
            </Button>
            <Button startIcon={<RefreshIcon />} onClick={fetch} disabled={loading} size="small" variant="outlined">
              {loading ? "جارٍ..." : "تحديث"}
            </Button>
          </Stack>
        </Stack>

        {loading ? (
          <Box sx={{ py: 4, display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ py: 2 }}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : groups && groups.length ? (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>اسم الشريحة</TableCell>
                  <TableCell>الدولة (AR)</TableCell>
                  <TableCell>Country (EN)</TableCell>
                  <TableCell>التكلفة</TableCell>
                  <TableCell align="center">إجراءات</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {groups.map((g) =>
                  (g.categories || []).map((cat) => (
                    <TableRow key={`${g.country?.id || "c"}-${cat.id}`}>
                      <TableCell>{cat.name || "-"}</TableCell>
                      <TableCell>{g.country?.name_ar || "-"}</TableCell>
                      <TableCell>{g.country?.name_en || "-"}</TableCell>
                      <TableCell>{formatMoney(cat.cost)}</TableCell>
                      <TableCell align="center">
                        <Stack direction="row" spacing={0.5} justifyContent="center">
                          <IconButton size="small" color="primary" onClick={() => handleViewGovernoratesClick(g.country, cat)}>
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" onClick={() => handleEditClick(cat, g.country?.id)}>
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" color="error" onClick={() => handleDeleteClick(cat)}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography color="text.secondary">لا توجد بيانات</Typography>
        )}
      </Paper>

      <AddShippingCategoriesDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSuccess={fetch}
      />

      <EditShippingCategoryDialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        onSuccess={fetch}
        category={selectedCategory}
        currentCountryId={selectedCountryId}
      />

      <DeleteShippingCategoryDialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onSuccess={fetch}
        category={categoryToDelete}
      />

      <Dialog
        open={openGovernoratesDialog}
        onClose={() => setOpenGovernoratesDialog(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          محافظات شريحة "{selectedCategoryForView?.name || ""}" - {selectedCountryForView?.name_ar || selectedCountryForView?.name_en || ""}
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <ShippingGovernotates 
            countryId={selectedCountryForView?.id} 
            categoryId={selectedCategoryForView?.id}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenGovernoratesDialog(false)}>إغلاق</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ShippingCategoriesTap;
